import {BatteryAddBody} from "./battery.interface";
import {Api} from "../../common/api/Api";

export async function postBatteries(body: BatteryAddBody) {
  await Api.post("/batteries", body)
}